import React, { useEffect, useState } from 'react';
import Icon from './Icon';
import './Toast.css';


const Toast = ({ message, type = 'info', duration = 5000, onClose, action, darkMode = true }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, 300);
  };

  if (!isVisible) return null;

  const iconMap = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
  };

  const colorMap = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
  };

  return (
    <div className={`toast toast-${type} ${isExiting ? 'toast-exiting' : ''}`}>
      <div className="toast-content">
        <span className="toast-icon">
          <Icon 
            name={iconMap[type] || 'info'} 
            color={colorMap[type] || 'info'} 
            darkMode={darkMode}
            size={20}
          />
        </span>
        <span className="toast-message">{message}</span>
        {action && (
          <button className="toast-action" onClick={action.onClick}>
            {action.label}
          </button>
        )}
      </div>
      <button className="toast-close" onClick={handleClose} aria-label="Close">
        ×
      </button>
    </div>
  );
};

export default Toast;











